import { Button, Group, Stack, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconBuildingBroadcastTower } from "@tabler/icons-react";
import { Suspense } from "react";
import { BadgeItem } from "shared/components/global/BadgeItem";
import { ComposeFormProvider, useComposeFormContext } from "shared/components/message/compose/context";
import { TopicTreeSelect } from "shared/components/topic/TopicTreeSelect";
import { features } from "shared/graphql/features";
import { useFormState } from "shared/hooks/useFormState";
import { useFormSubscription } from "shared/hooks/useFormSubscription";

export const AudienceTopicEditor = () => {
    features.useGuard("HAS_TOPICS");
    const form = useComposeFormContext();
    const topics = useFormSubscription(form, "audience.topics");

    function handleDeleteTopic(idx: number) {
        form.setFieldValue("audience.topics", (prev) => prev.toSpliced(idx, 1));
    }

    return (
        <Stack>
            <div>
                <Text fw="bold">Topics</Text>
                <Text c="dimmed" size="xs">
                    Send to users subscribed to a topic.
                </Text>
            </div>
            <Button
                variant="default"
                leftSection={<IconBuildingBroadcastTower size={16} />}
                onClick={() =>
                    modals.open({
                        title: "Select Topics",
                        children: (
                            <ComposeFormProvider form={form}>
                                <Modal />
                            </ComposeFormProvider>
                        ),
                    })
                }
            >
                Add Topics
            </Button>
            <Group>
                {topics.map((tpc, i) => (
                    <BadgeItem size="lg" key={tpc.id + i} onDelete={() => handleDeleteTopic(i)}>
                        {tpc.name}
                    </BadgeItem>
                ))}
            </Group>
        </Stack>
    );
};

const Modal = () => {
    const form = useComposeFormContext();
    const [values, handleChange] = useFormState(form, "audience.topics");

    return (
        <Suspense>
            <TopicTreeSelect values={values} onChange={handleChange} showRequiredLabel />
        </Suspense>
    );
};
